export default "__VITE_ASSET__DI6BHcu8__"